import { DirectiveBinding } from 'vue';

export default {
    name: 'scroll-window',
    mounted(el: Element, binding: DirectiveBinding) {
        window.addEventListener('scroll', binding.value);
    },
    beforeUnmount(el: Element, binding: DirectiveBinding) {
        window.removeEventListener('scroll', binding.value);
    },
};
